export default {
    apiUrl: process.env.REACT_APP_API_URL as string,
    appVersion: "2020.09.29.0"
};

